function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#fff",
  strokeWidth: 0.756
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.244,
  height: 14.244,
  x: 0.378,
  y: 0.378,
  rx: 1.476
}), /*#__PURE__*/React.createElement("path", {
  d: "M.402 3.874h17.03M12.331 1.655h1v1h-1zM14.963 1.655h1v1h-1z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M10.18 7.072l-2.34 4.204"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11.626 7.072l3.148 2.062-3.148 2.165M6.4 7.057L3.25 9.118 6.4 11.284"
}));

var SvgDeveloper = function SvgDeveloper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeveloper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/developer.d56d75f3.svg";
export { ForwardRef as ReactComponent };